import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    width: 1024,
    height: 576,
  },
  spinnerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 1024,
    height: 576,
  },
  lottieStyles: {
    zIndex: 9999,
    width: 1024,
    height: 576,
  },
});

export default styles;
